'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  font-family: \'spacesword\' !important;\n  font-feature-settings: \'liga\';\n  font-size: 110%;\n  font-variant: normal;\n  font-weight: normal !important;\n  letter-spacing: 0;\n  text-transform: none;\n'], ['\n  font-family: \'spacesword\' !important;\n  font-feature-settings: \'liga\';\n  font-size: 110%;\n  font-variant: normal;\n  font-weight: normal !important;\n  letter-spacing: 0;\n  text-transform: none;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _SVGTextStyle = require('./SVGTextStyle');

var _SVGTextStyle2 = _interopRequireDefault(_SVGTextStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

exports.default = (0, _styledComponents2.default)(_SVGTextStyle2.default).withConfig({
  displayName: 'SVGTextIconStyle'
})(_templateObject);
module.exports = exports['default'];